<div id="tools_left">
    <se-button id="tool_select" title="tools.mode_select" src="select.svg"></se-button>
    <se-button id="tool_zoom" title="tools.mode_zoom" src="zoom.svg" shortcut="Z / Alt + wheels"></se-button>
    <se-button id="tool_fhpath" title="tools.mode_fhpath" src="pencil.svg" shortcut="Q"></se-button>
    <se-button id="tool_line" title="tools.mode_line" src="pen.svg" shortcut="L"></se-button>
    <se-button id="tool_path" title="tools.mode_path" src="path.svg" shortcut="P"></se-button>
    <se-flyingbutton id="tools_rect" title="tools.square_rect_tool">
        <se-button id="tool_rect" title="tools.mode_rect" src="rect.svg" shortcut="R"></se-button>
        <se-button id="tool_square" title="tools.mode_square" src="square.svg"></se-button>
        <se-button id="tool_fhrect" title="tools.mode_fhrect" src="fh_rect.svg"></se-button>
    </se-flyingbutton>
    <se-flyingbutton id="tools_ellipse" title="tools.ellipse_circle_tool">
        <se-button id="tool_ellipse" title="tools.mode_ellipse" src="ellipse.svg" shortcut="E"></se-button>
        <se-button id="tool_circle" title="tools.mode_circle" src="circle.svg"></se-button>
        <se-button id="tool_fhellipse" title="tools.mode_fhellipse" src="fh_ellipse.svg"></se-button>
    </se-flyingbutton>
    <se-button id="tool_text" title="tools.mode_text" src="text.svg" shortcut="T"></se-button>
    <se-button id="tool_image" title="tools.mode_image" src="image.svg"></se-button>
</div>